import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider, CssBaseline } from '@mui/material';

import { AuthProvider } from './context/AuthContext';
import theme from './theme';

import LoginScreen from './screens/LoginScreen';
import DashboardScreen from './screens/DashboardScreen';
import SalesScreen from './screens/SalesScreen';
import SaleDetailScreen from './screens/SaleDetailScreen';
import SaleFormScreen from './screens/SaleFormScreen';
import PlatformsScreen from './screens/PlatformsScreen';
import PlatformEditScreen from './screens/PlatformEditScreen';
import UsersScreen from './screens/UsersScreen';
import UserFormScreen from './screens/UserFormScreen';
import ProfileScreen from './screens/ProfileScreen';
import NotFoundScreen from './screens/NotFoundScreen';
import ProductsScreen from './screens/ProductsScreen';
import ConversionsScreen from './screens/ConversionsScreen';
import ConversionDetailScreen from './screens/ConversionDetailScreen';
import ProductFormScreen from './screens/ProductFormScreen';
import ProductStatsScreen from './screens/ProductStatsScreen';
import ProductViewScreen from './screens/ProductViewScreen';
import ProductStatsDetailScreen from './screens/ProductStatsDetailScreen';
import ProductStatsFilteredScreen from './screens/ProductStatsFilteredScreen';
import ArticlesScreen from './screens/ArticlesScreen';
import ArticleDetailScreen from './screens/ArticleDetailScreen';

import Navbar from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

function App() {
  const location = useLocation();
  const isLoginRoute = location.pathname === '/login';

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <div data-theme="cem-premium" className="app-shell min-h-screen">
          <Toaster
            toastOptions={{
              style: {
                border: '1px solid #D7E0EA',
                borderRadius: '14px',
                background: '#FFFFFF',
                color: '#0F172A',
                boxShadow: '0 20px 45px -28px rgba(15, 23, 42, 0.28)',
              },
            }}
          />

          {!isLoginRoute && <Navbar />}

          <main className={isLoginRoute ? 'app-main-auth' : 'page-container app-main'}>
            <Routes>
              <Route path="/login" element={<LoginScreen />} />

              <Route path="/" element={<PrivateRoute><DashboardScreen /></PrivateRoute>} />
              <Route path="/dashboard" element={<PrivateRoute><DashboardScreen /></PrivateRoute>} />
              <Route path="/product-stats" element={<PrivateRoute><ProductStatsScreen /></PrivateRoute>} />
              <Route path="/product-stats/:id" element={<PrivateRoute><ProductStatsDetailScreen /></PrivateRoute>} />
              <Route path="/product-stats-filtered" element={<ProductStatsFilteredScreen />} />
              <Route path="/sales" element={<PrivateRoute><SalesScreen /></PrivateRoute>} />
              <Route path="/sales/:id" element={<PrivateRoute><SaleDetailScreen /></PrivateRoute>} />
              <Route path="/sales/new" element={<PrivateRoute><SaleFormScreen /></PrivateRoute>} />
              <Route path="/sales/edit/:id" element={<PrivateRoute><SaleFormScreen /></PrivateRoute>} />
              <Route path="/platforms" element={<PrivateRoute><PlatformsScreen /></PrivateRoute>} />
              <Route path="/platforms/edit/:id" element={<PrivateRoute><PlatformEditScreen /></PrivateRoute>} />
              <Route path="/products" element={<PrivateRoute><ProductsScreen /></PrivateRoute>} />
              <Route path="/products/:id" element={<PrivateRoute><ProductViewScreen /></PrivateRoute>} />
              <Route path="/products/new" element={<PrivateRoute><ProductFormScreen /></PrivateRoute>} />
              <Route path="/products/:id/edit" element={<PrivateRoute><ProductFormScreen /></PrivateRoute>} />
              <Route path="/articles" element={<PrivateRoute><ArticlesScreen /></PrivateRoute>} />
              <Route path="/articles/:id" element={<PrivateRoute><ArticleDetailScreen /></PrivateRoute>} />
              <Route path="/conversions" element={<PrivateRoute><ConversionsScreen /></PrivateRoute>} />
              <Route path="/conversions/:id" element={<PrivateRoute><ConversionDetailScreen /></PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute><ProfileScreen /></PrivateRoute>} />

              <Route path="/admin/users" element={<AdminRoute><UsersScreen /></AdminRoute>} />
              <Route path="/admin/users/new" element={<AdminRoute><UserFormScreen /></AdminRoute>} />
              <Route path="/admin/users/edit/:id" element={<AdminRoute><UserFormScreen /></AdminRoute>} />

              <Route path="*" element={<NotFoundScreen />} />
            </Routes>
          </main>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
